var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-layout',{attrs:{"column":""}},[_c('request-information-content',{attrs:{"text":_vm.data.request}}),(_vm.data.response)?_c('request-information-content',{staticClass:"mt-4",attrs:{"text":_vm.data.response}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }